import { useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../landingPage/Header";
import SetupLeft from "./SetupLeft";
import SetupRight from "./SetupRight";
import { examSetupSteps } from "../../../constant/Constants";

const Setup = () => {
  const [hasCameraPermission, sethasCameraPermission] = useState();
  const [hasMicPermission, sethasMicPermission] = useState();
  const [isMicWorking, setisMicWorking] = useState();
  const [hasInternetConnection, setHasInternetConnection] = useState();
  const { step } = useParams();

  return (
    <div className="">
      <Header placement="examModule" />
      <div className="w-full h-[100vh] flex items-center justify-center pt-20">
        <div className="bg-white w-[90%] flex rounded-[25px] shadow-[0_0_20px_rgba(0,0,0,0.05)] overflow-hidden">
          <div className="w-1/2 bg-[#FFE9C8] flex items-center justify-center">
            <SetupLeft
              step={step}
              hasCameraPermission={hasCameraPermission}
              sethasCameraPermission={sethasCameraPermission}
              hasMicPermission={hasMicPermission}
              sethasMicPermission={sethasMicPermission}
              setisMicWorking={setisMicWorking}
              hasInternetConnection={hasInternetConnection}
              setHasInternetConnection={setHasInternetConnection}
            />
          </div>
          <div className="w-[50%] h-[80vh] flex flex-col">
            <div className="flex gap-2.5 my-12 mx-[5%]">
              {examSetupSteps.map((stp) => (
                <div
                  key={stp}
                  className="h-[5px] w-full"
                  style={{
                    backgroundColor: step === stp ? "#F39C12" : "#E4E4E4",
                  }}
                />
              ))}
            </div>
            <SetupRight
              step={step}
              hasCameraPermission={hasCameraPermission}
              hasMicPermission={hasMicPermission}
              isMicWorking={isMicWorking}
              hasInternetConnection={hasInternetConnection}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setup;
